export default "/JMMMU/science.2580fdb1-6a7b95.jpg";